"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.406 10a9.5 9.5 0 0 0 2.065 2.539l1.127-1.127a2.7 2.7 0 0 1 .429-3.359 2.845 2.845 0 0 1 3.364-.434l.983-.983c-.784-.452-1.594-.704-2.374-.704-1.027 0-2.106.437-3.109 1.19C5.898 7.87 5.024 8.897 4.406 10m8.987-4.383C12.361 4.958 11.2 4.532 10 4.532c-1.42 0-2.787.597-3.95 1.472C4.883 6.88 3.877 8.07 3.17 9.34c-.227.41-.227.907 0 1.317a11 11 0 0 0 2.309 2.873l-.742.742a.7.7 0 1 0 .99.99l9.535-9.536a.7.7 0 1 0-.99-.99zm-3.075 3.075a1.44 1.44 0 0 0-1.315.365 1.3 1.3 0 0 0-.352 1.302zm3.794-1.684a.7.7 0 0 1 .99.013 11 11 0 0 1 1.727 2.32v.001c.228.41.228.907 0 1.316-.706 1.272-1.712 2.46-2.879 3.338-1.163.875-2.53 1.471-3.95 1.471-.801 0-1.585-.19-2.322-.51a.7.7 0 1 1 .558-1.284c.592.257 1.186.395 1.764.395 1.027 0 2.106-.437 3.109-1.19.992-.747 1.867-1.774 2.485-2.878a9.7 9.7 0 0 0-1.495-2.002.7.7 0 0 1 .013-.99",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EyeHideIcon20.js.map